const Strings = {
  SIGN_IN: 'Logga in',
  EMAIL_ADDRESS: 'Mailadress',
  PASSWORD: 'Lösenord',
  CREATE_ACCOUNT: 'Skapa konto',
  MISSING_FIELDS_HEADER: 'Fält saknas',
  MISSING_FIELDS: 'Var god fyll i samtliga fält och försök igen.',
  OK: 'Okej'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/Login/strings.js